import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <div className="bg-gray-100 text-containx-navy">
      {/* <div className="bg-tan text-center px-4 py-3 font-semibold shadow-md">
        📢 <span className="font-bold">Notice:</span> Starting June 30th, new
        store hours! We're now open{" "}
        <span className="underline">Mon–Fri 10AM–5PM</span>,{" "}
        <span className="underline">Sat 10AM–4PM</span>, and{" "}
        <span className="underline">closed on Sundays</span>.
      </div> */}

      {/* Hero Section */}
      <section className="flex flex-col items-center justify-center h-screen bg-containx-charcoal text-white p-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">
          Packaging Solutions
        </h1>
        <p className="text-lg md:text-xl mb-8 text-center px-4">
          Bags & Containers. Consider It Contained.{" "}
        </p>
        <span>
          <a
            href="/pdf/product-catalog.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-containx-navy font-semibold px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-lg hover:bg-containx-beige transition duration-300"
          >
            Products (PDF)
          </a>
        </span>
      </section>

      {/* Features Section */}
      <section className="py-10 md:py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-10">
            Our Features
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg text-center">
              <h3 className="text-lg md:text-xl font-semibold mb-2">
                Quality Products
              </h3>
              <p>
                Our plastic bags are made from high-quality resin sourced from
                the USA and undergo rigorous quality testing.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg text-center">
              <h3 className="text-lg md:text-xl font-semibold mb-2">
                Wholesale Pricing & Bulk Orders
              </h3>
              <p>
                Competitive pricing on bulk quantities to maximize your savings.
                Flexible order options for wholesalers, distributors, and
                restaurants.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg text-center">
              <h3 className="text-lg md:text-xl font-semibold mb-2">
                Exceptional Customer Service
              </h3>
              <p>
                At ContainX, we treat every customer like family. Our team is
                dedicated to providing personalized support, ensuring that you
                have everything you need for a seamless and stress-free
                experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-10 md:py-20 bg-gray-200">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
            Ready to Get Started?
          </h2>
          <p className="mb-4 md:mb-6">
            Call, text, or email us with any questions, concerns, or inquries!
          </p>
          <Link
            to="contact"
            className="bg-containx-tan text-white font-semibold px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-lg transition duration-300 hover:bg-containx-beige hover:text-containx-navy"
          >
            Contact Us!
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
